<template>
  <div>
    <button @click="GetPdf">getpdf</button>
    <a :href="url" target="_blank" v-if="url">open pdf</a>
  </div>
</template>

<script>
import { util } from 'pevueglobal'

// '../components/testtable.vue'
// naar pagina gaan via http://pe/peapp/testtablepage/

export default {
  name: 'testtablepage',
  data() {
    return {
      url: null,
    }
  },
  methods: {
    async GetPdf() {
      let pdfdata = await util.getDataApi('public/HtmlPDFGenerator/', {
        settings: {
          filename: 'test.pdf',
          template: 'voorbeeld/example1',
          htmlpreview: false,
          clientcss: 'string',
          PageOrientation: 'string',
        },
        Data: {
          name: 'gebruikers rapport',
          company: 'Xaurum',
          users: [{ name: 'kees' }, { name: 'jason' }, { name: 'karel' }],
        },
        Partialtemplates: ['voorbeeld/gebruiker'],
      })
      console.log(util.createApiUrl(pdfdata.url))
      this.url = util.createApiUrl(pdfdata.url)
    },
  },
}
</script>
<style>
</style>
